import { ROUTES } from '../../utils/constants';

export type SelectorGameId = 'skullKing' | 'flip7' | 'skyjo';

export const SELECTOR_LAST_GAME_STORAGE_KEY = 'table-de-jeux:last-opened-game:v1';

export const SELECTOR_GAME_ROUTES: Readonly<Record<SelectorGameId, string>> = Object.freeze({
  skullKing: ROUTES.HOME,
  flip7: ROUTES.FLIP7,
  skyjo: ROUTES.SKYJO,
});

export function isSelectorGameId(value: unknown): value is SelectorGameId {
  return value === 'skullKing' || value === 'flip7' || value === 'skyjo';
}

export function readLastOpenedGame(): SelectorGameId {
  try {
    const storedValue = window.localStorage.getItem(SELECTOR_LAST_GAME_STORAGE_KEY);
    return isSelectorGameId(storedValue) ? storedValue : 'skullKing';
  } catch {
    return 'skullKing';
  }
}

export function rememberLastOpenedGame(gameId: SelectorGameId): void {
  try {
    window.localStorage.setItem(SELECTOR_LAST_GAME_STORAGE_KEY, gameId);
  } catch {
    // Le sélecteur reste utilisable lorsque le stockage du navigateur est désactivé.
  }
}
